module.exports = __webpack_public_path__ + "static/media/banner_man.94c944ce.png";